import React,{Component} from "react";
import { withRouter } from 'react-router';
import Wrp from '../../../hoc/Wrp/Wrp';
import { connect } from 'react-redux';
import {callDELETE, callGET, callPOST} from '../../../Utils/ApiUtil';

import * as actions from '../../../store/actions';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import HeaderTabs from "../../../Components/UI/HeaderTabs";
import { getUserInfo,checkIsSystemUser,getUserWindows } from "../../../Utils/UserFunctions";
import * as ShipConstants from '../../../Global/Constants';
import {parameterizedURLAccessToken} from '../../../Utils/CommonFunctions';

class ExportContainer extends Component{

  state = {
    exportFormFields : {
          organization : {
            title : "Organization",
            field : "select",
            required : false,
            placeHolder : "",
            classname : 'form-control input-full',
            value : '',
            error: '',
            disabled:false,
            options : []
          },
          isDataSet : false,
          windowIds : []
        }
  }

  componentWillMount = () => {
    this.organizationList();
  }

  organizationList = () => {
    callGET("organizations/organization-list/?orderBy=organization_name&direction=ASC&page=0&size=1000000")
    .then(response => {
      const responseData = response.data.data;
      if(response.data.code === ShipConstants.API_STATUS_SUCCESS) {
        const updateState = {...this.state};
        updateState.exportFormFields['organization'].options = responseData.organization_list.content;
        this.setState(updateState);
      }
    }, (error) => {
        console.log(error);
    });
  }

  onChangeHandler = (event) => {
    const { name, value } = event.target;
    const updateState = { ...this.state };
    if(name === 'isDataSet') {
      updateState.exportFormFields[name]= event.target.checked;
      updateState.exportFormFields['windowIds']= [];
    }else if(name === 'windowIds') {
      if(event.target.checked === true) {
        updateState.exportFormFields['windowIds'].push(value);
      }else {
        updateState.exportFormFields['windowIds'].splice(updateState.exportFormFields['windowIds'].indexOf(value),1);
      }
    }else {
      updateState.exportFormFields[name].value= value;   
    }
    this.setState(updateState);
  }

  download = (arrayBuffer, type) => {
    console.log(arrayBuffer);
    var blob = new Blob([arrayBuffer], { type: type });
    var url = URL.createObjectURL(blob);
    window.open(url);
  }

  downloadZip = (res) => {
    console.log(res);
    const fileIds = this.getFileIds(res);
    let APIURL = "files/download-as-zip?file_ids="+fileIds;
    document.location.href = parameterizedURLAccessToken(APIURL);
    // const header = { 'Content-Type': 'application/json' };
    /*callPOST("files/download-as-zip?file_ids="+fileIds,{},header)
    .then(response => {
      const responseData = response.data;
      console.log(responseData);
      this.download(responseData,'application/zip');
    })
    .catch(err => {
      // this.props.failMessage("Error occured");
      console.log(err);
    })*/
  }

  getFileIds = (res) => {
    let fileIds = '';
    res.map((arr,i) => {
      fileIds += arr.id+',';
      // return true;
    })
    return fileIds;
  }

  exportHandler = () => {
    console.log(this.state.exportFormFields.organization.value);
    this.props.Loader();
    const orgId = this.state.exportFormFields.organization.value;
    const header = { 'Content-Type': 'application/json' };
    let postData = this.state.exportFormFields.windowIds;

    callPOST("export-metadata/xml/all/"+orgId,postData,header)
    .then(response => {
      this.props.Loader();
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
        this.props.succMessage(responseData.message);
        this.downloadZip(responseData.data);
      }else {
        this.props.failMessage(responseData.message);
      }
    })
    .catch(err => {
      this.props.Loader();
      this.props.failMessage("Error occured");
      console.log(err);
    })
  }

  render(){
    const params = this.props.match.params;

    const breadCrumbs =  {
        backHistory : [{
        href : "/settings",
        name:"Settings"
        }],
        pageTitle:"Import/Export",
        buttonList:[]
    }

    //HEADER TABS
    const headerTabs =  [{
      name:"Import",
      attributes:{
          "aria-selected":false,
          className:"nav-link"
      },
      href:"/import-export/import",
    },
    {
      name:"Export",
      attributes:{
          "aria-selected":true,
          className:"nav-link active show"
      },
      href:"/import-export/export",
    },{
      name:"ImportV2",
      attributes:{
          "aria-selected":false,
          className:"nav-link"
      },
      href:"/import-export/import-v2",
    },
    {
      name:"ExportV2",
      attributes:{
          "aria-selected":false,
          className:"nav-link "
      },
      href:"/import-export/export-v2",
    }]
    const userWindows = getUserWindows();
    return (
      <Wrp>
        <BreadCrumbs breadCrumbsList={breadCrumbs} />
        <div className="viewport">
          <div className="view view--hor-scroll filters-v3 view-xl">
            
            <div className="view view--hor-scroll" >
               <HeaderTabs 
                attributes={{
                  className:"nav nav-pills navcrm-primary nav-pills-no-bd fixed-2",
                }} 
                headerTabsList={headerTabs} />

                <div className="row">
                  <div className="col-12">
                    <div className="mt-5"> 

                      <div className="card-body">
                        <div className="row">
                          <div className="col-6">
                              <div className="form-group row">
                                  <label className="col-lg-3 col-md-3 col-sm-4">Include Dataset</label>
                                  <div className="col-lg-9 col-md-9 col-sm-8">
                                  <div className="material-switch p-2">
                                      <input id="isDataSet" 
                                      name="isDataSet" 
                                      type="checkbox" 
                                      checked={this.state.exportFormFields.isDataSet}
                                      onChange={this.onChangeHandler}
                                      />
                                      <label htmlFor="isDataSet" className="secondary_bg"></label>
                                  </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                        {
                          this.state.exportFormFields.isDataSet === true ?
                          <div className="row mb-2">
                            <div className="col-12">
                              <div className="selectgroup-pills w-100 border-bottom pb-2 display-flex">
                                {/*<h6 className="pr-2">Apply Workflow for </h6>*/}
                                {
                                  userWindows ?
                                    userWindows.map((arr,i) => {
                                      return (
                                        <label className="selectgroup-item mb-1" key={i}>
                                          <input 
                                            type="checkbox" 
                                            name="windowIds" 
                                            value={arr.window_id} 
                                            className="selectgroup-input" 
                                            windowname={arr.window_name}
                                            onChange={this.onChangeHandler}
                                            checked={this.state.exportFormFields.windowIds.indexOf(arr.window_id) === -1 ? false : true}
                                          />
                                          <span className="selectgroup-button">{arr.window_name}</span>
                                        </label>
                                      );
                                    })
                                  : null
                                }
                              </div>
                            </div>
                          </div>
                          : null
                        }
                        <div className="row">
                          <div className="col-6">
                            <div className="form-group row">
                              <label htmlFor="inlineinput" className="col-lg-3 col-md-3 col-sm-4">
                              { checkIsSystemUser() ? 'Choose Organisation' : 'Export'}</label> 

                              <div className="col-lg-9 col-md-9 col-sm-8">
                                 <div className="form-group">
                                 <div className="input-group mb-3">
                                  {
                                    checkIsSystemUser() ? 
                                      <select className="form-control" name="organization" onChange={e=>this.onChangeHandler(e)}>
                                        <option value=""></option>
                                        {
                                          this.state.exportFormFields.organization.options.map((arr,i) => {
                                            return <option key={i} value={arr.id}>{arr.organization_name}</option>
                                          })
                                        }
                                      </select> 
                                    : null
                                  }  
                                    <div className="input-group-append">
                                        <span onClick={this.exportHandler} className="input-group-text cursor-pointer" data-toggle="tooltip" data-placement="top" data-title="Import" data-trigger="hover"><i className="fas fa-file-import fa-lg"></i></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                             
                            </div> 
                          </div>
                          
                          {/*<div className="col-6"> 
                            <div className="form-group row">
                              <label htmlFor="inlineinput" className="col-lg-3 col-md-3 col-sm-4">Select Import Window</label> 

                              <div className="col-lg-9 col-md-9 col-sm-8">
                                 <div className="form-group">
                                  <div className="input-group mb-3">  
                                    <select className="form-control"></select>
                                    <div className="input-group-append">
                                      <span className="input-group-text cursor-pointer" data-toggle="tooltip" data-placement="top" data-title="Import" data-trigger="hover"><i className="fas fa-file-import fa-lg"></i></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                             
                            </div> 
                          </div>*/} 
                           
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


            </div>   
          </div>
        </div>      
      </Wrp>
      
    );        
  }
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : () => dispatch(actions.loader()),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))    
  };
}
export default
  connect(
    null, 
    mapDispatchToProps
  )(withRouter(ExportContainer));